import classNames from "classnames";
import isEqual from "lodash/isEqual";
import React from "react";
import { Option, OptionPropsUnion } from "web/react/components/select/types";
import styles from "./options.css";

export interface OptionsProps {
    isExpanded: boolean;
    onClick: (option: Option) => () => void;
    OptionComponent: (optionComponentProps: OptionPropsUnion) => JSX.Element;
    optionHeadingElement?: JSX.Element;
    options: Option[];
    selectedOption: Option;
}

export default function Options({
    isExpanded,
    onClick,
    OptionComponent,
    optionHeadingElement,
    options,
    selectedOption,
}: OptionsProps): JSX.Element {
    return (
        <div className={classNames(styles.optionsWrapper, { [styles.expanded]: isExpanded })}>
            {optionHeadingElement}
            <div className={styles.options}>
                {options.map((option) => {
                    const isSelected = isEqual(option.value, selectedOption.value);
                    return (
                        <OptionComponent
                            isSelected={isSelected}
                            onClick={onClick(option)}
                            option={option}
                            key={option.text.toString()}
                        />
                    );
                })}
            </div>
        </div>
    );
}
